import { RoutePath } from "#src/utils/route";
import { FormCategoriesRoute } from "..";

export const linkToFormCategoryDetails = (formCategoryId = ":categoryId") =>
  `/app/forms/categories/${formCategoryId}`;

export const FORM_CATEGORY_DETAILS_PAGE_TITLE_PLACEHOLDER =
  "Form Category:categoryId";

export const FORM_CATEGORY_DETAILS_BREADCRUMB = {
  title: FORM_CATEGORY_DETAILS_PAGE_TITLE_PLACEHOLDER,
  path: linkToFormCategoryDetails,
};

export const FormCategoryDetailsRoute = FormCategoriesRoute.concat(
  new RoutePath<"categoryId">({
    path: "/:categoryId",
    title: "Form Category Details",
  })
);
